import { Injectable } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable()
export class StateStorageService {
    constructor(
        private $sessionStorage: SessionStorageService
    ) {}

    getPreviousState(): string {
        return this.$sessionStorage.retrieve('previousState');
    }

    resetPreviousState(): void {
        this.$sessionStorage.clear('previousState');
    }

    storePreviousState(previousState: string) {
        if (previousState) {
            this.$sessionStorage.store('previousState', previousState);
        }
    }

    getDestinationState(): string {
        return this.$sessionStorage.retrieve('destinationState');
    }

    storeDestinationState(destinationState: string) {
        if (destinationState) {
            this.$sessionStorage.store('destinationState', destinationState);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/state-storage.service.ts